<template>
    <div class="menu">
        <div class="logo-box">
            <img src="../assets/logo.png" class="logo">
        </div>
        <div class="menu-box">
            <div class="item" :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">HOME </div>
            <div class="item" :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">PRIVACY POLICY</div>
            <!-- <div class="item" :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">CONTACT</div> -->
            <!-- <div class="item" :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">POLÍTICA DE PRIVACIDAD</div> -->
        </div>
    </div>
</template>
<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "Privacy" }); break;
                // case 3: this.$router.push({ path: "ContactUs" }); break;
                // case 4: this.$router.push({ path: "ContactUs" }); break;
                // case 5: this.$router.push({ path: "aboutUs" }); break;
                // case 5: this.$router.push({ path: "cooperate" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 360px;

    .logo-box {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFF;
        text-align: center;
        font-family: Poppins;
        font-size: 40px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;

        .logo {
            width: 242px;
        }
    }


    .menu-box {
        display: flex;
        width: 350px;
        justify-content: space-between;
        font-weight: 500;
        color: #fff;
        cursor: pointer;

        .item {
            padding: 0px 10px;
            color: #FFF;
            font-family: Helvetica;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            text-transform: capitalize;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 168px;
        }
    }

    .select {
        min-width: 98px;
        height: 40px;
        flex-shrink: 0;
        border-radius: 20px;
        background: #437E38;


    }
}
</style>